import logo from './logo.svg';
import './App.css';
import { Button, Form } from "react-bootstrap";
import Modal from 'react-bootstrap/Modal';
import { useState } from "react";
import Card from 'react-bootstrap/Card';
import translate from "translate";
import 'bootstrap/dist/css/bootstrap.min.css';
import TextLoading from './components/loading'




function App() {
  const [textoriginal, setTextoriginal] = useState('');
  const [texttranslation, setTexttranslation] = useState('');
  const [language, setLanguage] = useState("es")
  const [loading, setLoading] = useState(false)

  const translatetospan = (text) => {
    translate.engine = "google"; // Or "yandex", "libre", "deepl"
    translate.key = process.env.GOOGLE_KEY;
    setLoading(true)
    translate(text, { from: "en", to: language }).then((res) => {
      setTexttranslation(res);
      setLoading(false)
    });


  }

  return (
    <div className="container">
      <div className="row mt-3" style={{ padding: '10px 3px' }}>
        <div className='form-group'>
          <label htmlFor="select">Choose Language:</label>
          <select id="select" className="language-select form-control" value={language} onChange={(e) => setLanguage(e.target.value)}>
            <option value="es">Spanish</option>
            <option value="pt">Portuguese</option>
            <option value="ht">Haitian Creole</option>
          </select>
        </div>

      </div>
      <div style={{ display: "flex", flexDirection: "row" }}>
        <Card style={{ order: 1, width: "50%" }}>
          <Card.Body>
            <Card.Title>English</Card.Title>
            <Form>
              <Form.Group controlId="exampleForm.ControlTextarea1">
                <Form.Control style={{ resize: "none", height: "17em" }} placeholder='Write something...' as="textarea" value={textoriginal} onChange={(e) => setTextoriginal(e.target.value)} />
              </Form.Group>
            </Form>
          </Card.Body>
        </Card>

        <Card style={{ order: 1, width: "50%" }}>
          <Card.Body>
            <Card.Title>{language === "es" ? "Spanish" : language === "ht" ? "Haitian Creole" : "Portuguese"}</Card.Title>
            <Card.Text style={{
              maxHeight: "95%",
              overflowY: "auto",
              height: "17em", border: '1px solid rgba(0,0,0,0.2)',
              borderRadius: '5px',
              padding: '5px 10px'
            }} >
              {
                loading ? <TextLoading /> : texttranslation
              }
            </Card.Text>
          </Card.Body>
        </Card>
      </div>
      <div className='row text-center'>
        <Button style={{ margin: "10px" }} onClick={() => { translatetospan(textoriginal) }}>Translate</Button>
      </div>
    </div>
  );
}

export default App;
